import axios from 'axios';

/**
 * Compromisso de votos por liderança (proto:1707-1716): quanto uma liderança
 * promete entregar num território, num ciclo eleitoral. É cadastro do
 * gabinete — não confundir com apuração do TSE.
 */
export interface CompromissoVotoApi {
  id: string;
  tenant_id: string;
  lideranca_id: string;
  bairro: string;
  ciclo: number;
  votos_prometidos: number;
  created_at: string;
  updated_at: string;
}

export interface CompromissoBairroApi {
  bairro_id: string;
  bairro: string;
  compromissos: Array<{
    id: string;
    lideranca_id: string;
    lideranca_nome: string;
    lideranca_tipo: string;
    votos_prometidos: number;
  }>;
  total_prometido: number;
}

export interface CriarCompromissoVoto {
  lideranca_id: string;
  bairro: string;
  ciclo: number;
  votos_prometidos: number;
}

export interface AtualizarCompromissoVoto {
  bairro?: string;
  ciclo?: number;
  votos_prometidos?: number;
}

const API_URL = import.meta.env.VITE_API_URL || '/api';
const auth = (token: string) => ({ headers: { Authorization: `Bearer ${token}` } });

export const compromissosVotosApi = {
  list: async (token: string, ciclo?: number) => {
    const res = await axios.get<CompromissoVotoApi[]>(`${API_URL}/eleg/compromissos-votos`, {
      ...auth(token),
      params: ciclo ? { ciclo } : undefined,
    });
    return res.data;
  },

  resumo: async (token: string, ciclo?: number) => {
    const res = await axios.get<CompromissoBairroApi[]>(
      `${API_URL}/eleg/compromissos-votos/resumo`,
      { ...auth(token), params: ciclo ? { ciclo } : undefined },
    );
    return res.data;
  },

  create: async (data: CriarCompromissoVoto, token: string) => {
    const res = await axios.post<CompromissoVotoApi>(
      `${API_URL}/eleg/compromissos-votos`,
      data,
      auth(token),
    );
    return res.data;
  },

  update: async (id: string, data: AtualizarCompromissoVoto, token: string) => {
    const res = await axios.put<CompromissoVotoApi>(
      `${API_URL}/eleg/compromissos-votos/${id}`,
      data,
      auth(token),
    );
    return res.data;
  },

  delete: async (id: string, token: string) => {
    await axios.delete(`${API_URL}/eleg/compromissos-votos/${id}`, auth(token));
  },
};
